import React, { useContext } from 'react';
import { Button, InlineLoader } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { pageTemplateProps } from 'gw-portals-wizard-react';
import styles from './BuildingsAndLocationsTemplate.module.scss';
import WizardStepCircles from '../wizardStepCirlces/WizardStepCircles';

function renderLoader(isLoading) {
    return isLoading ? <InlineLoader loading={isLoading} className="gw-inline-loader" /> : null;
}

function BuildingLocationPageTemplate(props) {
    const translator = useContext(TranslatorContext);
    const {
        children: content,
        onNext,
        isLoadingNext,
        disableNext,
        showNext,
        nextLabel,
        onCancel,
        isLoadingCancel,
        disableCancel,
        showCancel,
        cancelLabel
    } = props;

    const isPerformingTransiton = isLoadingNext;

    const isNextDisabled = disableNext || isPerformingTransiton;

    return (
        <div>
            <WizardStepCircles />
            {content}
            <div className={styles.wizardButtons}>
                {showCancel && (
                    <Button
                        id="gw-wizard-cancel"
                        disabled={disableCancel || isPerformingTransiton}
                        type="tertiary"
                        onClick={onCancel}
                    >
                        {translator(cancelLabel)}
                        {renderLoader(isLoadingCancel)}
                    </Button>
                )}
                {showNext && (
                    <Button id="gw-wizard-Next" disabled={isNextDisabled} onClick={onNext}>
                        {translator(nextLabel)}
                        {renderLoader(isLoadingNext)}
                    </Button>
                )}
            </div>
        </div>
    );
}

BuildingLocationPageTemplate.propTypes = {
    ...pageTemplateProps
};

export default BuildingLocationPageTemplate;
